<template>
    <div class="portal-members-table" v-if="portalMembers">
        <table class="table header-table is-narrow">
            <thead>
            <tr>
                <th
                    :key="header"
                    v-for="header in tableHeader"
                >
                    {{ $t(`${header}`) }}
                </th>
            </tr>
            </thead>
            <tbody>
            <template>
                <tr
                    :key="member.id"
                    v-for="member in filteredMembers"
                >
                    <td>{{
                            getCampsiteName(member.campsite_id, member.accommodation_maintype)
                        }}
                    </td>
                    <td>{{ member.state }}</td>
                    <td>{{ getDate(member.valid_from, member.valid_to) }}</td>
                    <td>
                        <EditAccommodation
                            :campsites="campsites"
                            :portal="portal"
                            :member="member"
                            @update-portal="updatePortal"
                        />

                        <template v-for="state in stateChanges">
                            <Modal
                                v-if="showStateChange(member.state_id, state.key)"
                                :key="state.key"
                                class="d-inline-block "
                                :title="$t(`portals.table.modal.${state.modalKey}Title`)"
                            >
                                <p>{{ $t(`portals.table.modal.${state.modalKey}`) }}</p>
                                <template #activator>
                                    <i
                                        class="fa pointer mr-2"
                                        :class="`fa-${state.icon}`"
                                        aria-hidden="true"
                                    />
                                </template>

                                <template #footer="{ toggleModal }">
                                    <button
                                        class="button is-primary"
                                        @click="changeState(member.id, state.key)"
                                    >
                                        {{ $t('generic.save') }}
                                    </button>
                                    <button class="button" @click="toggleModal">{{ $t('generic.close') }}</button>
                                </template>
                            </Modal>
                        </template>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import { AppModel } from '../../../models';
import moment from 'moment';
import EditAccommodation from './editAccommodation.vue';
import { Api } from '../../../api';
import { EventBus } from '../../../utils';
import { Modal } from '../index';

export default {
    name: 'portalMembersTable',
    components: { EditAccommodation, Modal },
    props: {
        campsites: Array,
        portal: Object,
        portalMembers: Array,
    },
    data() {
        return {
            stateChanges: [
                {
                    key: 'ACTIVE',
                    icon: 'play',
                    modalKey: 'activate',
                },
                {
                    key: 'PAUSED',
                    icon: 'pause',
                    modalKey: 'pause',
                },
                {
                    key: 'CANCELED',
                    icon: 'stop',
                    modalKey: 'cancel',
                },
            ],
            showModal: false,
            editingPortal: null,
            tableHeader: [
                'portals.table.type',
                'portals.table.state',
                'portals.table.timeframe',
                'portals.table.edit',
            ],
        };
    },
    computed: {
        filteredMembers() {
            return this.portalMembers.filter((member) => member.portal_id === this.portal.id && member.campground_slug === AppModel.activeCampground.slug);
        },
    },
    methods: {
        getPortalName(portalId) {
            const portal = AppModel.portals.find((portal) => portal.id === portalId);

            return portal.name;
        },
        getCampsiteName(campsiteId, accoMaintype) {
            const campsite = this.campsites.find((campsite) => campsite.id === campsiteId);
            if(!campsite && accoMaintype) {
                return this.$t('generic.campsite_types.' + accoMaintype + '.portal_select_name');
            }

            return campsite ? campsite.name : this.$t('generic.campsite_types.all.portal_select_name');
        },
        getDate(validFrom, validTo) {
            const from = validFrom ? moment(validFrom).format('L') : '';
            const to = validTo ? moment(validTo).format('L') : '';

            return from && to ? `${from} - ${to}` : '';
        },
        edit(portal) {
            this.toggleModal();
            this.editingPortal = portal;
        },
        toggleModal() {
            this.showModal = !this.showModal;
        },
        updatePortal() {
            this.$emit('update-portal');
        },
        async changeState(memberId, state) {
            const data = {
                campground_slug: AppModel.activeCampground.slug,
                portal_id: this.portal.id,
                state,
            };
            const response = await Api.portalMembers.changeState(memberId, data);
            const notification = {
                title: response.status === 400 ? this.$t('generic.formErrorHeadline') : this.$t('generic.saveSuccess'),
                body: response.body.msg,
                type: response.status === 400 ? 'danger' : 'success',
                direction: 'Up',
                duration: 3000,
            };

            EventBus.$emit(EventBus.SHOW_NOTIFICATION, notification);

            this.updatePortal();
        },
        showStateChange(memberState, state) {
            if(memberState === 'ACTIVE' && state !== 'ACTIVE') {
                return true;
            } else if(memberState === 'PAUSED' && state === 'ACTIVE') {
                return true;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/components/portals/portalMembersTable.vue